export var InputKeySpecial;
(function (InputKeySpecial) {
    InputKeySpecial[InputKeySpecial["Shift"] = 0] = "Shift";
    InputKeySpecial[InputKeySpecial["Ctrl"] = 1] = "Ctrl";
    InputKeySpecial[InputKeySpecial["Alt"] = 2] = "Alt";
    InputKeySpecial[InputKeySpecial["Cmd"] = 3] = "Cmd";
})(InputKeySpecial || (InputKeySpecial = {}));
